import {Checkbox, FormControl, FormLabel, Grid2 as Grid} from "@mui/material";
import React from "react";

interface FormCheckboxProps {
  name: string;
  label: string;
  values?: Record<string, boolean>;
  value?: boolean;
  onChange?: (name: string, value: boolean) => void;
}

export default function FormCheckbox({
  name,
  label,
  values = {},
  value,
  onChange = () => {
  }
}: FormCheckboxProps) {
  return <Grid container justifyContent="center" alignItems="center" wrap={"nowrap"} size={12}>
    <Grid size={11}>
      <FormLabel style={{marginLeft: 5}} htmlFor={name}>{label}</FormLabel>
    </Grid>
    <Grid size={1}>
      <FormControl fullWidth>
        <Checkbox
          name={name}
          id={name}
          data-testid={name}
          checked={values[name] ?? value ?? false}
          onChange={e => onChange(name, e.target.checked)}
          size={"medium"}
          title={label}
          aria-label={label} />
      </FormControl>
    </Grid>
  </Grid>;
}
